import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { useNarrativeUpload } from '@/features/narrative/hooks/useNarrativeUpload';
import { type DateRangeFilter } from '@/utils/constants';

interface SimpleMutation<TArgs> {
  mutate: (
    args: TArgs,
    options?: { onError?: (error: unknown) => void; onSuccess?: () => void },
  ) => void;
}

interface UseNarrativeFileUploadOptions {
  markWalkthroughUploaded: () => void;
  narrativePreferencesMutation: SimpleMutation<{ data: { sampleNarratives: Array<string> } }>;
  setActiveFilter: (filter: DateRangeFilter) => void;
}

export function useNarrativeFileUpload({
  markWalkthroughUploaded,
  narrativePreferencesMutation,
  setActiveFilter,
}: UseNarrativeFileUploadOptions) {
  const { t } = useTranslation();
  return useNarrativeUpload({
    onFileSelected: () => {},
    onUploadError: () => {
      toast.error(t('narrative.toast.uploadFilesFailed'));
    },
    onUploadSuccess: (uploadResponse) => {
      const attachmentIds = uploadResponse.map((item) => item.id);
      if (attachmentIds.length === 0) {
        toast.error(t('narrative.toast.processFilesFailed'));
        return;
      }

      setActiveFilter('today');
      markWalkthroughUploaded();

      narrativePreferencesMutation.mutate({
        data: { sampleNarratives: attachmentIds },
      });
    },
  });
}
